// 合并批次：第25批（家居/产品设计类 + 食品合规，IDs 154-157）
//           第27批（内容运营扩展类，IDs 182-184）
export const talentsBatch2527 = [
  // ==================== 第25批 ====================
  {
    id: 154,
    name: '魏雯英',
    role: '文创产品设计师',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20male%20cultural%20creative%20product%20designer%20in%20artistic%20casual%20attire%20inspired%20expression%20age%2032%20clean%20simple%20background%20corporate%20headshot%20style%20realistic%20photography&width=400&height=600&seq=talent-b25-003&orientation=portrait',
    salary: '¥1750/月',
    tags: ['文创设计', '文化元素', '创意转化', '小批量工艺', '场景效果', '文化IP'],
    description: '文化创意产品设计专家，擅长文化元素提取与转化和文创产品方案生成，将文化转化为商品。',
    skills: [
      { name: '文化元素提取', level: 97 },
      { name: '创意转化能力', level: 96 },
      { name: '文创方案生成', level: 95 },
      { name: '小批量工艺', level: 93 },
      { name: '场景效果模拟', level: 94 },
    ],
    performance: { products_designed: 120, cultural_authenticity: '95%' },
    cases: [
      { title: '某博物馆文创产品开发', result: '提取馆藏文物元素，设计50+款文创产品，文化内涵丰富，销售额突破500万，成为博物馆收入重要来源', duration: '4个月', tags: ['博物馆文创', '文物元素', '销售成功', '文化传播'] },
      { title: '某景区文创IP开发', result: '开发景区文创IP，设计系列文创产品，产品成为景区特色，游客购买率85%，年销售额破千万', duration: '5个月', tags: ['景区文创', 'IP开发', '特色产品', '销售破千万'] },
      { title: '某传统文化品牌文创设计', result: '将传统文化元素现代化转化，设计时尚文创产品，年轻消费者占比80%，品牌年轻化成功', duration: '3个月', tags: ['传统文化', '现代转化', '年轻化', '品牌成功'] },
    ],
    reviews: [
      { name: '尹馆长', company: '某博物馆', rating: 5, content: '萧志强的文创设计能力非常出色，他能够很好地提取文物元素并转化为现代产品。他的设计让我们的文创产品销售额大幅提升。', date: '2024-01-30' },
      { name: '穆景区总经理', company: '某旅游景区', rating: 5, content: '他开发的文创IP非常成功，设计的产品成为了景区的特色。游客都很喜欢购买，销售额超出预期。', date: '2024-02-22' },
      { name: '萧品牌经理', company: '某文化品牌', rating: 5, content: '他的文化转化能力很强，把传统元素变得时尚现代。他的设计让我们成功吸引了年轻消费者，品牌年轻化很成功。', date: '2024-03-18' },
    ],
    profile: {
      identity: { roleName: '文创产品设计专家，专注于将文化元素转化为有市场价值的创意产品', personality: '文化素养高、善于转化、注重创意、市场敏感，能够平衡文化性和商业性', background: '产品设计或文化产业专业背景，精通文化研究、创意设计、产品开发，熟悉文创市场' },
      mission: { duties: '负责文化元素提取与转化、文创产品方案生成、小批量工艺适配、场景效果模拟', goals: '设计有文化内涵的文创产品，文化还原度达到95%以上，市场成功率达到85%以上', collaboration: '与文化专家确认元素，与工厂对接工艺，与市场团队分析定位' },
      delivery: { example: '输出文创产品方案、效果图、文化说明、材料清单、场景效果图', workflow: '1.文化研究 → 2.元素提取 → 3.创意转化 → 4.方案设计 → 5.工艺适配 → 6.效果模拟 → 7.样品确认', format: '提供设计方案、效果图、文化文档、材料清单、场景图等标准化交付物' },
      metrics: { quality: '文化还原度、创意性、市场适配度、工艺可行性、销售表现', acceptance: '文化元素准确，创意新颖，市场定位准确，工艺可实现，销售表现好', improvement: '持续研究文化元素，提升转化能力，优化设计方案，关注市场反馈' },
    },
  },
  {
    id: 155,
    name: '秦思涵',
    role: '家居设计师',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20male%20home%20product%20designer%20in%20modern%20creative%20attire%20warm%20expression%20age%2033%20clean%20simple%20background%20corporate%20headshot%20style%20realistic%20photography&width=400&height=600&seq=talent-b25-004&orientation=portrait',
    salary: '¥1875/月',
    tags: ['家居产品', '系列设计', '材料匹配', '人体工学', '场景搭配', '生活美学'],
    description: '家居产品设计开发专家，擅长系列家居方案生成和材料匹配与效果图制作，打造美好生活空间。',
    skills: [
      { name: '系列家居设计', level: 96 },
      { name: '材料匹配能力', level: 94 },
      { name: '人体工学尺寸', level: 95 },
      { name: '场景搭配模拟', level: 97 },
      { name: '生活美学应用', level: 93 },
    ],
    performance: { home_products: 150, market_success_rate: '87%' },
    cases: [
      { title: '某家居品牌收纳系列设计', result: '设计模块化收纳系列产品，美观实用，空间利用率高，产品上市后销量突破30万套，获家居设计奖', duration: '3个月', tags: ['收纳系列', '模块化', '销量突破', '设计奖项'] },
      { title: '某生活方式品牌家居线', result: '开发完整家居产品线，风格统一，场景搭配和谐，品牌家居业务营收占比提升至40%', duration: '6个月', tags: ['产品线开发', '风格统一', '营收增长', '业务拓展'] },
      { title: '某环保家居产品设计', result: '设计环保材料家居产品，可持续理念，市场反响热烈，获绿色设计奖，品牌形象大幅提升', duration: '4个月', tags: ['环保家居', '可持续', '绿色设计', '品牌提升'] },
    ],
    reviews: [
      { name: '穆品牌总监', company: '某家居品牌', rating: 5, content: '尹建华的家居设计能力很强，他设计的收纳系列既美观又实用。他对空间利用的优化让产品更有竞争力了。', date: '2024-01-30' },
      { name: '萧CEO', company: '某生活方式品牌', rating: 5, content: '他开发的家居产品线风格统一，场景搭配非常和谐。他的设计让我们的家居业务成为了新的增长点。', date: '2024-02-22' },
      { name: '尹市场经理', company: '某环保品牌', rating: 5, content: '他的环保家居设计理念很先进，产品既环保又美观。他的设计获得了绿色设计奖，提升了我们的品牌形象。', date: '2024-03-18' },
    ],
    profile: {
      identity: { roleName: '家居产品设计专家，专注于创造美观、实用、有品质感的家居产品', personality: '生活品味高、注重细节、善于搭配、市场敏感，能够将生活美学转化为产品设计', background: '产品设计或环境艺术专业背景，精通家居设计、材料应用、空间搭配，熟悉家居市场趋势' },
      mission: { duties: '负责系列家居方案生成、材料匹配与效果图、人体工学尺寸调整、场景搭配模拟', goals: '设计有品质感的家居产品，市场成功率达到85%以上，客户满意度达到95%以上', collaboration: '与品牌团队确认风格，与工厂对接工艺，与空间设计师协作搭配' },
      delivery: { example: '输出家居产品方案、效果图、材料清单、尺寸规格、场景搭配图', workflow: '1.需求分析 → 2.系列规划 → 3.产品设计 → 4.材料匹配 → 5.尺寸优化 → 6.场景模拟 → 7.方案输出', format: '提供设计方案、效果图、材料清单、尺寸图、场景图等标准化交付物' },
      metrics: { quality: '设计美观度、实用性、材料适配性、场景协调性、市场表现', acceptance: '设计美观实用，材料匹配合理，场景搭配和谐，市场反响好', improvement: '持续学习生活美学，探索新材料，优化设计方案，关注市场趋势' },
    },
  },
  {
    id: 156,
    name: '穆俊豪',
    role: '玻璃制品设计师',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20male%20glass%20product%20designer%20in%20refined%20business%20casual%20attire%20elegant%20expression%20age%2035%20clean%20simple%20background%20corporate%20headshot%20style%20realistic%20photography&width=400&height=600&seq=talent-b25-005&orientation=portrait',
    salary: '¥2000/月',
    tags: ['玻璃设计', '工艺匹配', '通透效果', '折射模拟', '模具图纸', '玻璃工艺'],
    description: '玻璃材质产品设计与开发专家，擅长玻璃制品造型生成和工艺自动匹配，打造精美的玻璃艺术品。',
    skills: [
      { name: '玻璃造型设计', level: 97 },
      { name: '工艺自动匹配', level: 95 },
      { name: '通透折射效果', level: 96 },
      { name: '模具图纸输出', level: 94 },
      { name: '玻璃工艺知识', level: 93 },
    ],
    performance: { glass_products: 60, production_success_rate: '96%' },
    cases: [
      { title: '某高端玻璃器皿设计', result: '设计高端玻璃酒杯系列，造型优雅，工艺精湛，产品获红点设计奖，成为品牌明星产品，销售额破500万', duration: '4个月', tags: ['玻璃器皿', '高端设计', '红点奖', '销售成功'] },
      { title: '某灯具品牌玻璃灯罩设计', result: '设计创意玻璃灯罩，光影效果出众，通透折射美观，产品成为网红爆款，销量突破10万件', duration: '3个月', tags: ['玻璃灯罩', '光影效果', '网红爆款', '销量突破'] },
      { title: '某艺术玻璃装置设计', result: '设计大型艺术玻璃装置，工艺复杂，效果震撼，装置成为城市地标，获艺术设计大奖', duration: '6个月', tags: ['艺术装置', '工艺复杂', '城市地标', '艺术奖项'] },
    ],
    reviews: [
      { name: '萧品牌总监', company: '某玻璃品牌', rating: 5, content: '穆建国的玻璃设计能力非常出色，他设计的酒杯造型优雅，工艺精湛。他的设计获得了红点奖，成为我们的明星产品。', date: '2024-01-30' },
      { name: '尹产品经理', company: '某灯具品牌', rating: 5, content: '他设计的玻璃灯罩光影效果非常美，通透折射的模拟很真实。他的设计成了网红爆款，销量超出预期。', date: '2024-02-22' },
      { name: '穆艺术总监', company: '某艺术机构', rating: 5, content: '他设计的艺术玻璃装置非常震撼，工艺难度很高但他都实现了。他的作品成为了城市地标，获得了艺术大奖。', date: '2024-03-18' },
    ],
    profile: {
      identity: { roleName: '玻璃制品设计专家，专注于创造精美、独特的玻璃艺术产品', personality: '审美优秀、注重工艺、善于创新、追求完美，能够将玻璃材质的特性发挥到极致', background: '产品设计或材料科学专业背景，精通玻璃设计、玻璃工艺、光学原理，熟悉玻璃生产流程' },
      mission: { duties: '负责玻璃制品造型生成、工艺自动匹配、通透/折射效果模拟、模具图纸输出', goals: '设计精美的玻璃产品，生产成功率达到95%以上，市场成功率达到85%以上', collaboration: '与客户确认需求，与玻璃厂对接工艺，与工程师确认模具' },
      delivery: { example: '输出玻璃产品方案、效果图、工艺说明、模具图纸、光影模拟', workflow: '1.造型设计 → 2.工艺匹配 → 3.效果模拟 → 4.模具设计 → 5.样品确认 → 6.生产跟进 → 7.质量验收', format: '提供设计图纸、3D效果图、工艺文档、模具图纸、光影渲染等标准化交付物' },
      metrics: { quality: '造型美观度、工艺可行性、光影效果、生产成功率、市场表现', acceptance: '造型优美，工艺可实现，光影效果好，生产顺利，市场反响好', improvement: '持续探索新工艺，提升设计创意，优化光影效果，关注市场反馈' },
    },
  },
  {
    id: 157,
    name: '萧雅琪',
    role: '食品标签合规审核员',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20female%20food%20labeling%20compliance%20specialist%20in%20professional%20business%20attire%20meticulous%20expression%20age%2030%20clean%20simple%20background%20corporate%20headshot%20style%20realistic%20photography&width=400&height=600&seq=talent-b25-006&orientation=portrait',
    salary: '¥1625/月',
    tags: ['标签合规', '营养标签', '文字审核', '图案审核', '法规更新', '风险提示'],
    description: '食品包装标签、文字、图案的法规符合性审核专家，擅长标签要素完整性检查和营养标签合规审核。',
    skills: [
      { name: '标签要素检查', level: 97 },
      { name: '营养标签审核', level: 96 },
      { name: '文字用语规范', level: 95 },
      { name: '图案版面合规', level: 94 },
      { name: '法规库更新', level: 93 },
    ],
    performance: { labels_audited: 500, compliance_rate: '99%' },
    cases: [
      { title: '某食品企业标签合规审核', result: '审核200+款产品标签，发现并修正合规问题80+个，产品全部通过市场监管审查，避免罚款风险', duration: '3个月', tags: ['标签审核', '合规检查', '风险规避', '监管通过'] },
      { title: '某进口食品标签本地化', result: '审核进口食品标签中文化，确保符合中国法规，50+款产品顺利进入中国市场', duration: '2个月', tags: ['进口食品', '标签本地化', '法规符合', '市场准入'] },
      { title: '某食品公司法规库建设', result: '建立食品标签法规库，实时更新法规变化，为企业100+款产品提供合规保障', duration: '持续服务', tags: ['法规库', '实时更新', '合规保障', '风险预防'] },
    ],
    reviews: [
      { name: '尹质量总监', company: '某食品企业', rating: 5, content: '萧雅琪的标签审核非常专业，她对食品法规的理解很深刻。她的审核帮我们避免了很多合规风险，产品全部顺利通过了监管审查。', date: '2024-01-30' },
      { name: '穆进口业务经理', company: '某进口食品公司', rating: 5, content: '她的标签本地化审核非常细致，确保了我们的进口产品符合中国法规。她的专业能力让我们的产品顺利进入了中国市场。', date: '2024-02-22' },
      { name: '萧合规经理', company: '某食品公司', rating: 5, content: '她建立的法规库非常实用，法规更新及时。她的合规审核让我们的产品标签管理更规范了，合规风险大幅降低。', date: '2024-03-18' },
    ],
    profile: {
      identity: { roleName: '食品标签合规审核专家，专注于确保食品包装标签符合法律法规要求', personality: '细致严谨、责任心强、法规敏感、善于沟通，能够准确识别合规风险', background: '食品科学或法律专业背景，精通食品安全法、标签法规、营养标签标准，熟悉食品行业' },
      mission: { duties: '负责标签要素完整性检查、营养标签合规审核、文字用语规范性审核、图案版面合规性、法规库自动更新、风险提示与修改建议、多版本比对、合规审核报告', goals: '确保标签合规，合规率达到99%以上，避免监管处罚，保护企业声誉', collaboration: '与设计师确认标签设计，与法规部门对接标准，与生产部门协调修改' },
      delivery: { example: '输出合规审核报告、问题清单、修改建议、风险提示、合规证明', workflow: '1.标签接收 → 2.要素检查 → 3.营养审核 → 4.文字审核 → 5.图案审核 → 6.风险识别 → 7.报告输出', format: '提供审核报告、问题清单、修改建议、合规文档、法规参考等标准化交付物' },
      metrics: { quality: '审核准确率、合规符合率、问题发现率、修改建议可行性、法规更新及时性', acceptance: '审核准确全面，合规问题发现及时，修改建议可行，通过监管审查', improvement: '持续学习法规变化，优化审核流程，完善法规库，提升审核效率' },
    },
  },

  // ==================== 第27批 ====================
  {
    id: 182,
    name: '双志强',
    role: '用户运营',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20male%20user%20operations%20specialist%20in%20smart%20business%20casual%20attire%20with%20user%20segmentation%20data%20and%20engagement%20metrics%20clean%20simple%20background%20corporate%20headshot%20style%20strategic%20analytical%20expression%20age%2030%20realistic%20photography&width=400&height=600&seq=talent-b27-018&orientation=portrait',
    salary: '¥1500/月',
    tags: ['用户运营', '用户标签', '分层运营', '核心用户', '专属活动', '用户生命周期'],
    description: '粉丝/用户精细化运营与关系维护专家，擅长用户标签体系建立和分层内容推送，提升用户价值和忠诚度。',
    skills: [
      { name: '用户标签体系', level: 97 },
      { name: '分层内容推送', level: 96 },
      { name: '核心用户互动', level: 95 },
      { name: '专属活动策划', level: 94 },
      { name: '用户价值分析', level: 93 },
    ],
    performance: { users_managed: 100000, ltv_improvement: '+85%' },
    cases: [
      { title: '某电商平台用户分层运营', result: '建立用户标签体系，实施分层运营策略，高价值用户占比从15%提升至35%，用户LTV提升85%', duration: '1年', tags: ['分层运营', '标签体系', '高价值用户', 'LTV提升'] },
      { title: '某品牌核心用户运营', result: '识别并运营核心用户5000+人，建立专属社群和活动，核心用户贡献营收占比达60%', duration: '8个月', tags: ['核心用户', '专属运营', '营收贡献', '高占比'] },
      { title: '某APP用户召回项目', result: '通过精准分层和个性化推送，召回流失用户3万+，召回率35%，召回用户留存率70%', duration: '3个月', tags: ['用户召回', '精准推送', '召回率高', '留存率高'] },
    ],
    reviews: [
      { name: '方运营经理', company: '某电商平台', rating: 5, content: '双志强的用户运营能力非常专业，他建立的标签体系很完善。他的分层运营让我们的高价值用户占比提升到了35%，用户LTV提升了85%。', date: '2024-01-30' },
      { name: '孔电商经理', company: '某电商公司', rating: 5, content: '他的核心用户运营做得很好，专属社群和活动让核心用户很有归属感。他运营的核心用户贡献了60%的营收。', date: '2024-02-22' },
      { name: '严内容总监', company: '某APP公司', rating: 5, content: '他的用户召回项目非常成功，召回了3万+流失用户。他的精准推送让召回率和留存率都很高。', date: '2024-03-18' },
    ],
    profile: {
      identity: { roleName: '用户运营专家，专注于通过精细化运营提升用户价值和忠诚度', personality: '数据驱动、善于分析、注重价值、服务意识强，能够识别和培养高价值用户', background: '市场营销或用户运营专业背景，精通用户运营、数据分析、CRM系统，熟悉用户生命周期管理' },
      mission: { duties: '负责用户标签体系建立、分层内容推送、核心用户互动、专属活动策划、用户价值提升', goals: '提升用户价值，高价值用户占比达到30%以上，用户LTV提升80%以上', collaboration: '与数据团队建立标签，与内容团队协作推送，与活动团队策划专属活动' },
      delivery: { example: '输出用户标签体系、分层运营方案、核心用户名单、专属活动方案、价值分析报告', workflow: '1.标签体系建立 → 2.用户分层 → 3.内容推送 → 4.核心用户互动 → 5.活动策划 → 6.价值分析 → 7.策略优化', format: '提供标签体系、运营方案、用户名单、活动方案、分析报告等标准化交付物' },
      metrics: { quality: '高价值用户占比、用户LTV、活跃度、转化率、用户满意度', acceptance: '高价值用户占比提升，LTV增长，活跃度高，转化效果好，用户满意', improvement: '持续优化标签体系，完善分层策略，提升用户价值，加强关系维护' },
    },
  },
  {
    id: 183,
    name: '孙建国',
    role: '新媒体数据分析师',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20female%20social%20media%20data%20analyst%20in%20modern%20professional%20attire%20with%20data%20dashboards%20analytics%20charts%20and%20metrics%20displays%20clean%20simple%20background%20corporate%20headshot%20style%20analytical%20focused%20expression%20age%2029%20realistic%20photography&width=400&height=600&seq=talent-b27-019&orientation=portrait',
    salary: '¥1625/月',
    tags: ['数据分析', '多平台采集', '数据仪表盘', '内容趋势', '优化建议', '数据可视化'],
    description: '新媒体各平台数据采集、分析与可视化专家，擅长多平台数据采集和数据仪表盘搭建，为运营决策提供数据支持。',
    skills: [
      { name: '多平台数据采集', level: 96 },
      { name: '数据仪表盘搭建', level: 95 },
      { name: '内容趋势分析', level: 97 },
      { name: '优化建议报告', level: 94 },
      { name: '数据可视化', level: 93 },
    ],
    performance: { platforms_monitored: 12, insight_accuracy: '94%' },
    cases: [
      { title: '某品牌新媒体数据中台', result: '搭建新媒体数据中台，整合12个平台数据，实时监控运营效果，数据驱动决策，整体ROI提升60%', duration: '1年', tags: ['数据中台', '多平台整合', '实时监控', 'ROI提升'] },
      { title: '某企业内容趋势分析', result: '分析内容数据，识别爆款内容特征，指导内容创作，内容爆款率从35%提升至72%', duration: '8个月', tags: ['趋势分析', '爆款特征', '创作指导', '爆款率提升'] },
      { title: '某电商新媒体优化', result: '通过数据分析优化新媒体策略，识别高ROI渠道和内容类型，营销成本降低40%，转化率提升50%', duration: '5个月', tags: ['策略优化', '渠道识别', '成本降低', '转化提升'] },
    ],
    reviews: [
      { name: '孔市场总监', company: '某品牌', rating: 5, content: '孙建国的数据分析能力非常强，她搭建的数据中台让我们能够实时监控所有平台的运营效果。她的数据分析让我们的ROI提升了60%。', date: '2024-01-30' },
      { name: '严内容总监', company: '某企业', rating: 5, content: '她的内容趋势分析非常专业，帮我们识别了爆款内容的特征。她的分析指导让我们的内容爆款率提升到了72%。', date: '2024-02-22' },
      { name: '汤电商经理', company: '某电商公司', rating: 5, content: '她的数据分析帮我们找到了高ROI的渠道和内容类型。她的优化建议让我们的营销成本降低了40%，转化率提升了50%。', date: '2024-03-18' },
    ],
    profile: {
      identity: { roleName: '新媒体数据分析专家，专注于通过数据分析为新媒体运营提供决策支持', personality: '数据敏感、逻辑严密、善于洞察、注重实效，能够从数据中发现运营机会', background: '数据分析或市场营销专业背景，精通数据分析、数据可视化、BI工具，熟悉各类新媒体平台' },
      mission: { duties: '负责多平台数据采集、数据仪表盘搭建、内容趋势分析、优化建议报告、数据可视化', goals: '提供准确的数据洞察，洞察准确率达到90%以上，帮助运营决策，提升ROI 50%以上', collaboration: '与运营团队确认需求，与技术团队对接数据，与管理层汇报洞察' },
      delivery: { example: '输出数据仪表盘、趋势分析报告、优化建议报告、数据可视化图表、运营洞察', workflow: '1.数据采集 → 2.数据清洗 → 3.仪表盘搭建 → 4.趋势分析 → 5.洞察提炼 → 6.建议输出 → 7.效果跟踪', format: '提供数据看板、分析报告、可视化图表、优化建议、洞察文档等标准化交付物' },
      metrics: { quality: '数据准确性、分析深度、洞察价值、建议可行性、ROI提升效果', acceptance: '数据准确完整，分析深入，洞察有价值，建议可落地，ROI提升显著', improvement: '持续优化数据模型，提升分析能力，完善仪表盘，关注业务反馈' },
    },
  },
  {
    id: 184,
    name: '孔欣怡',
    role: '短视频剪辑师',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20female%20video%20editor%20in%20creative%20modern%20attire%20with%20video%20editing%20timeline%20software%20interface%20and%20editing%20equipment%20clean%20simple%20background%20corporate%20headshot%20style%20focused%20creative%20expression%20age%2025%20realistic%20photography&width=400&height=600&seq=talent-b27-020&orientation=portrait',
    salary: '¥1375/月',
    tags: ['视频剪辑', '素材剪辑', '字幕特效', '背景音乐', '批量输出', 'Premiere'],
    description: '短视频素材剪辑、包装、调色、音效制作专家，擅长素材自动剪辑和字幕/特效添加，打造精美短视频。',
    skills: [
      { name: '素材自动剪辑', level: 96 },
      { name: '字幕特效添加', level: 95 },
      { name: '背景音乐匹配', level: 94 },
      { name: '多尺寸批量输出', level: 97 },
      { name: '调色能力', level: 93 },
    ],
    performance: { daily_videos: 20, editing_efficiency: '95%' },
    cases: [
      { title: '某MCN机构批量剪辑', result: '为MCN机构日均剪辑短视频20+条，建立剪辑模板库，剪辑效率提升300%，视频质量稳定，播放量平均15万+', duration: '持续服务', tags: ['批量剪辑', '模板库', '效率提升', '质量稳定'] },
      { title: '某品牌多平台视频适配', result: '为品牌视频适配抖音、快手、视频号等多平台尺寸，自动批量输出，适配效率提升10倍', duration: '2个月', tags: ['多平台适配', '批量输出', '效率飞跃', '尺寸优化'] },
      { title: '某电商产品视频剪辑', result: '剪辑产品短视频800+条，统一调色风格，字幕特效专业，视频转化率提升45%', duration: '6个月', tags: ['产品视频', '风格统一', '专业剪辑', '转化提升'] },
    ],
    reviews: [
      { name: '严内容总监', company: '某MCN机构', rating: 5, content: '孔欣怡的剪辑效率非常高，她建立的模板库让我们的剪辑效率提升了3倍。她剪辑的视频质量稳定，播放量都很不错。', date: '2024-01-30' },
      { name: '汤运营经理', company: '某品牌', rating: 5, content: '她的多平台适配能力很强，能够自动批量输出不同尺寸的视频。她的工作让我们的适配效率提升了10倍。', date: '2024-02-22' },
      { name: '邱电商总监', company: '某电商品牌', rating: 5, content: '她剪辑的产品视频调色风格统一，字幕特效很专业。她的剪辑让我们的视频转化率提升了45%。', date: '2024-03-18' },
    ],
    profile: {
      identity: { roleName: '短视频剪辑专家，专注于通过高效专业的剪辑提升视频质量和传播效果', personality: '注重细节、效率高、审美优秀、技术扎实，能够快速剪辑出高质量短视频', background: '影视制作或数字媒体专业背景，精通Premiere、Final Cut Pro、DaVinci Resolve，熟悉短视频剪辑技巧' },
      mission: { duties: '负责素材自动剪辑、字幕/特效添加、背景音乐匹配、多尺寸批量输出、调色处理', goals: '高效剪辑高质量短视频，日均产出20条以上，剪辑效率提升300%以上', collaboration: '与编导团队对接脚本，与拍摄团队获取素材，与运营团队确认需求' },
      delivery: { example: '输出剪辑视频、多尺寸版本、字幕文件、音频文件、剪辑工程', workflow: '1.素材整理 → 2.粗剪 → 3.精剪 → 4.字幕特效 → 5.音乐配合 → 6.调色 → 7.多尺寸输出', format: '提供视频文件、多尺寸版本、字幕文件、工程文件等标准化交付物' },
      metrics: { quality: '剪辑质量、剪辑效率、视觉美观度、音画同步、播放量', acceptance: '剪辑质量高，效率快，视觉美观，音画同步，播放量达标', improvement: '持续优化剪辑流程，提升剪辑技巧，完善模板库，提高剪辑效率' },
    },
  },
];
